import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { IGetUserGuidedTours } from 'crono-fe-common/types/guidedTours';

export default function useGetUserGuidedTours() {
  const request: Request = {
    url: ENDPOINTS.user.guidedTours,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.user.guidedTours],
    queryFn: () => client(request),
    staleTime: 10 * 60 * 1000,
  };

  const { data, ...rest } = useQuery<
    Response<IGetUserGuidedTours | null>,
    CronoError
  >(requestConfig);

  return { data, ...rest };
}
